import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (typeof value == 'string') {
      return value.length > 20 ? value.slice(0, 20) + '...' : value;
    }
    else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/truncate.pipe.ts